<template>
    <div class="register-page">
        <!-- 顶部图标和欢迎语 -->
        <div class="register-header">
            <img class="img" :src="require('../assets/images/loginIcon.png')" />
            <span class="welcome-text">你好，欢迎使用~</span>
        </div>

        <!-- 登录卡片 -->
        <div class="register-card-wrapper">
            <div class="register-card">
                <!-- Tab 切换 -->
                <van-tabs v-model="activeTab" color="#5573f1" title-active-color="#5573f1"
                    title-inactive-color="#858b95" @change="onTabChange">
                    <van-tab title="验证码登录" name="code">
                        <van-form>
                            <van-field v-model="registerForm.mobile" type="tel" center clearable label="手机号"
                                placeholder="请输入11位手机号码"
                                :rules="[{ required: true, }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]" />
                            <van-field v-model="registerForm.code" type="number" center clearable label="验证码"
                                placeholder="请输入短信验证码" :rules="[{ required: true }]">
                                <template #button>
                                    <van-button native-type="button" size="small" type="info" plain hairline
                                        @click="getCode" :disabled="countdown > 0">
                                        {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
                                    </van-button>
                                </template>
                            </van-field>
                        </van-form>
                    </van-tab>

                    <van-tab title="密码登录" name="pwd">
                        <van-form>
                            <van-field v-model="registerForm.mobile" type="tel" center clearable label="手机号"
                                placeholder="请输入11位手机号码"
                                :rules="[{ required: true, }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]" />
                            <van-field v-model="registerForm.password" :type="showPassword ? 'text' : 'password'" center
                                clearable label="密码" placeholder="请输入密码" :rules="[{ required: true, }]">
                                <!-- 小眼睛图标插槽 -->
                                <template #right-icon>
                                    <van-icon :name="showPassword ? 'eye-o' : 'closed-eye'" class="password-icon"
                                        @click="togglePassword" />
                                </template>
                            </van-field>
                        </van-form>
                    </van-tab>
                </van-tabs>
            </div>
        </div>
        <div v-if="activeTab == 'code'" class="tip-text">未注册的手机号登录后自动创建账号</div>
        <div v-else class="pwd-tip-wrapper">
            <van-checkbox v-model="rememberPwd">记住密码</van-checkbox>
            <span class="forget-pwd" @click="resetPassword"> 忘记密码？</span>
        </div>
        <van-button type="primary" size="normal" :disabled="!loginEnable" native-type="submit" round
            class="register-btn" @click="login">
            登录
        </van-button>
    </div>
</template>

<script>
import * as deviceApi from "@/api/device"
export default {
    name: 'RegisterView',
    data() {
        return {
            activeTab: 'code',
            registerForm: {
                mobile: '',
                code: '',
                password: ''
            },
            countdown: 0,
            rememberPwd: false,
            timer: null,
            showPassword: false
        }
    },
    computed: {
        loginEnable() {
            const { mobile, code, password } = this.registerForm;
            return (this.activeTab == "code" && !!mobile && !!code) || (this.activeTab == "pwd" && !!mobile && !!password)
        },
    },
    mounted() {
        this.loadRememberedPwd();
    },
    methods: {
        // 切换密码显示/隐藏状态
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        onTabChange(name) {
            console.log('切换到', name)
        },
        getCode() {
            if (!this.registerForm.mobile || !this.validatePhone(this.registerForm.mobile)) {
                this.$toast('请先输入正确的手机号')
                return
            }
            // 发送验证码
            deviceApi.sendSmsCode(this.registerForm.mobile).then(data => {
                this.$toast.success("验证码已发送");
                this.countdown = 60
                this.timer = setInterval(() => {
                    this.countdown--
                    if (this.countdown <= 0) {
                        clearInterval(this.timer)
                        this.timer = null
                    }
                }, 1000);
            }).catch(err => {
                console.error("发送验证码失败", err);
                if (err.message) {
                    this.$toast(err.message);
                }
            });

        },
        handleCodeRegister() {
            deviceApi.smsLogin(this.registerForm.mobile, this.registerForm.code).then(data => {
                console.log("登录成功", data);
                const { userId, deviceNo } = data;
                if (!deviceNo) {
                    this.goBindDevicePage(userId);
                } else {
                    this.goDeviceHome(deviceNo);
                }


            }).catch(err => {
                console.error("验证码登录失败", err);
                if (err.message) {
                    this.$toast(err.message);
                }
            });
        },
        handlePwdRegister() {
            deviceApi.pwdLogin(this.registerForm.mobile, this.registerForm.password).then(data => {
                console.log("登录成功", data);
                // 判断是否勾选“记住密码”
                if (this.rememberPwd) {
                    // 存储账号密码到localStorage
                    localStorage.setItem('user_login_info', JSON.stringify({
                        mobile: this.registerForm.mobile,
                        password: this.registerForm.password
                    }));
                } else {
                    // 不记住：清除本地存储
                    localStorage.removeItem('user_login_info');
                }
                const { deviceNo, userId } = data;
                if (!deviceNo) {
                    this.goBindDevicePage(userId);
                } else {
                    this.goDeviceHome(deviceNo);
                }

            }).catch(err => {
                console.error("验证码登录失败", err);
                if (err.message) {
                    this.$toast(err.message);
                }
            });
        },
        resetPassword() {
            this.$router.push({ path: '/resetPwd' });
        },
        login() {
            if (!this.validatePhone(this.registerForm.mobile)) {
                this.$toast('请输入正确的手机号')
                return;
            }
            if (this.activeTab == 'code') {
                this.handleCodeRegister()
            } else {
                this.handlePwdRegister()
            }
        },
        goBindDevicePage(userId) {
            this.$router.replace({
                path: '/addDevice',
                query: {
                    _u: userId
                }
            });
        },
        goDeviceHome(deviceNo) {
            this.$router.replace({
                path: '/deviceHome',
                query: {
                    _t: deviceNo
                }
            });
        },
        // 手机号校验
        validatePhone(phone) {
            const reg = /^(?:\+86|86-?)?1[3-9]\d{9}$/;
            // 先去除前后空格，再校验
            return reg.test(phone);
        },
        // 加载记住的密码
        loadRememberedPwd() {
            const savedInfo = localStorage.getItem('user_login_info');
            if (savedInfo) {
                const { mobile, password } = JSON.parse(savedInfo);
                this.registerForm.mobile = mobile;
                this.registerForm.password = password;
                this.rememberPwd = true; // 勾选框自动选中
            }
        }

    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>

<style lang="scss" scoped>
.register-page {
    height: 100vh;
    font-size: 12px;
    background: #f1f4f9;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.register-header {
    width: 100%;
    background: linear-gradient(180deg, #d4e1f8, hsla(0, 0%, 100%, 0));
    text-align: center;
    padding-top: 30px;
    font-size: 14px;
    color: #7a89a0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .img {
        width: 72px;
        margin-bottom: 10px;
    }
}

.register-card-wrapper {
    width: 100%;
    padding: 20px 15px;

    .register-card {
        width: 100%;
        background: #fff;
        border-radius: 16px;
    }
}

.title-tab {
    background: url(../assets/images/login-tab-icon.png);
    background-size: cover;
}

.tip-text {
    align-self: flex-start;
    font-size: 13px;
    margin: 0 15px;
    color: #f35252;
    font-weight: 500;
}

.pwd-tip-wrapper {
    width: 100%;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin: 0 15px;
    font-weight: 500;
    color: #000018;

    .forget-pwd {
        color: #5573f1;
    }
}

.register-btn {
    margin-top: 20px;
    width: 50%;
}

// 小眼睛图标样式（可选，适配UI）
.password-icon {
    font-size: 18px;
    color: #999;

    // 点击反馈
    &:active {
        color: #1989fa; // Vant主色，可替换为你的主题色
    }
}

::v-deep .van-button--primary {
    background-color: #5573f1;
    border-color: #5573f1;
}
</style>
